function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { z } from "zod";
export var serUint8ArraySchema = z.object({
    $type: z.literal("Uint8Array"),
    data: z.instanceof(ArrayBuffer)
});
export var serUint16ArraySchema = z.object({
    $type: z.literal("Uint16Array"),
    data: z.instanceof(ArrayBuffer)
});
export var serFloat32ArraySchema = z.object({
    $type: z.literal("Float32Array"),
    data: z.instanceof(ArrayBuffer)
});
var serArraySchema = z.discriminatedUnion("$type", [
    serUint8ArraySchema,
    serUint16ArraySchema,
    serFloat32ArraySchema
]);
var miscValueSchema = z.union([
    z.string(),
    z.number()
]);
export var serArrayRecordSchema = z.record(z.string(), serArraySchema.or(miscValueSchema));
var parsableArraySchema = z.union([
    z.instanceof(Uint8Array),
    z.instanceof(Uint16Array),
    z.instanceof(Float32Array)
]);
var parsableArrayRecordSchema = z.record(z.string(), parsableArraySchema.or(miscValueSchema));
function isParsableArray(data) {
    return _instanceof(data, Uint8Array) || _instanceof(data, Uint16Array) || _instanceof(data, Float32Array);
}
function serializeArray(data) {
    if (_instanceof(data, Uint8Array)) {
        return {
            $type: "Uint8Array",
            data: data.buffer
        };
    }
    if (_instanceof(data, Uint16Array)) {
        return {
            $type: "Uint16Array",
            data: data.buffer
        };
    }
    if (_instanceof(data, Float32Array)) {
        return {
            $type: "Float32Array",
            data: data.buffer
        };
    }
    throw new Error("unreachable");
}
function serializeArrayRecord(data) {
    return Object.fromEntries(Object.entries(data).map(function(param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
        if (isParsableArray(value)) {
            return [
                key,
                serializeArray(value)
            ];
        }
        return [
            key,
            value
        ];
    }));
}
function deserializeArray(data) {
    switch(data.$type){
        case "Uint8Array":
            return new Uint8Array(data.data);
        case "Uint16Array":
            return new Uint16Array(data.data);
        case "Float32Array":
            return new Float32Array(data.data);
    }
}
function deserializeArrayRecord(data) {
    return Object.fromEntries(Object.entries(data).map(function(param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
        if ((typeof value === "undefined" ? "undefined" : _type_of(value)) === "object" && "$type" in value) {
            return [
                key,
                deserializeArray(value)
            ];
        }
        return [
            key,
            value
        ];
    }));
}
export { serializeArrayRecord, deserializeArrayRecord };
